// CASE ASSIGNMENT ENDPOINTS — Phase L
import { buildEndpoint, buildEndpointWithParams, buildEndpointWithQuery } from './base.endpoints';
import type { ID } from '../types';

const BASE = '/CaseAssignment';

export const caseAssignmentEndpoints = {
  roles: () => buildEndpoint(`${BASE}/roles`),
  byCase: (caseId: ID, openOnly = false) =>
    buildEndpointWithQuery(`${BASE}/by-case/${caseId}`, { openOnly }),
  create: () => buildEndpoint(BASE),
  close: (assignmentId: ID) => buildEndpointWithParams(`${BASE}/:assignmentId`, { assignmentId }),
};

export default caseAssignmentEndpoints;
